var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.showItem
    ? _c("li", [
        _c(
          "div",
          {
            class: [
              _vm.isRoot ? "cw-tree-item-is-root" : "",
              _vm.isFirstLevel ? "cw-tree-item-first-level" : "",
              _vm.hasPurposeClass ? "cw-tree-item-" + _vm.purposeClass : ""
            ]
          },
          [
            _c(
              "router-link",
              {
                staticClass: "cw-tree-item-link",
                class: {
                  "cw-tree-item-link-current": _vm.isCurrent
                },
                attrs: {
                  to: "/structural_element/" + _vm.element.id
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.element.attributes.title || "–") +
                    "\n            "
                ),
                _vm.task
                  ? _c("span", [_vm._v("| " + _vm._s(_vm.solverName))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasReleaseOrWithdrawDate
                  ? _c("span", {
                      staticClass: "cw-tree-item-flag-date",
                      attrs: {
                        title: _vm.$gettext(
                          "Diese Seite hat eine zeitlich beschränkte Sichtbarkeit"
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasWriteApproval
                  ? _c("span", {
                      staticClass: "cw-tree-item-flag-write",
                      attrs: {
                        title: _vm.$gettext(
                          "Diese Seite kann von Teilnehmenden bearbeitet werden"
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasNoReadApproval
                  ? _c("span", {
                      staticClass: "cw-tree-item-flag-cant-read",
                      attrs: {
                        title: _vm.$gettext(
                          "Diese Seite kann von Teilnehmenden nicht gesehen werden"
                        )
                      }
                    })
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasChildren
          ? _c(
              "ul",
              {
                class: {
                  "cw-tree-chapter-list": _vm.isRoot,
                  "cw-tree-subchapter-list": _vm.isFirstLevel
                }
              },
              _vm._l(_vm.children, function(child) {
                return _c("courseware-tree-item", {
                  key: child.id,
                  staticClass: "cw-tree-item",
                  attrs: {
                    element: child,
                    currentElement: _vm.currentElement,
                    depth: _vm.depth + 1
                  }
                })
              }),
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }